import {
  FirebaseApp,
  FirebaseOptions,
  getApp,
  getApps,
  initializeApp,
} from "firebase/app";
import { Database, getDatabase } from "firebase/database";
import { getMessaging, Messaging } from "firebase/messaging";
import { getAuth, Auth } from "firebase/auth";

// Detect environment based on the API URL injected by env-cmd
const apiUrl = process.env.REACT_APP_URL || "";

// Prefer an explicit REACT_APP_FIREBASE_ENV (set in .env.dev/.env.prod) so the
// Firebase project is never silently mis-selected. Fall back to URL inference
// only when the explicit flag is absent (legacy builds).
const explicitFirebaseEnv = (process.env.REACT_APP_FIREBASE_ENV || "")
  .trim()
  .toLowerCase();
const isProd =
  explicitFirebaseEnv === "prod"
    ? true
    : explicitFirebaseEnv === "dev"
      ? false
      : apiUrl.includes("api.statdoctor.app") && !apiUrl.includes("api-dev");
/*
console.log(
  `🔥 Firebase Init: Detected ${isProd ? "PRODUCTION" : "DEVELOPMENT"} mode (API: ${apiUrl})`,
);
*/
const devConfig: FirebaseOptions = {
  apiKey: "AIzaSyBeFTHItbrkKfZVrqGx6ucxlJxllpxUcGA",
  authDomain: "statdoctor-dev.firebaseapp.com",
  databaseURL: "https://statdoctor-dev-default-rtdb.firebaseio.com",
  projectId: "statdoctor-dev",
  storageBucket: "statdoctor-dev.firebasestorage.app",
  messagingSenderId: "245103680627",
  appId: "1:245103680627:web:c3d64c0f7068d017db1e06",
  measurementId: "G-NVYHFP7GT4",
};

export const prodConfig: FirebaseOptions = {
  apiKey: "AIzaSyCaCuMlnVnbcKBxPvB_jAuqc8O4G38ZvUQ",
  authDomain: "statdoctor-in-use.firebaseapp.com",
  databaseURL:
    "https://statdoctor-in-use-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "statdoctor-in-use",
  storageBucket: "statdoctor-in-use.firebasestorage.app",
  messagingSenderId: "1045985830744",
  appId: "1:1045985830744:web:de1267f85ef47f3700e72d",
  measurementId: "G-SZ5DRJ44PT",
};

const firebaseConfig = isProd ? prodConfig : devConfig;

// Allow override from environment variables if present (optional)
if (process.env.REACT_APP_FIREBASE_API_KEY)
  firebaseConfig.apiKey = process.env.REACT_APP_FIREBASE_API_KEY;
if (process.env.REACT_APP_FIREBASE_AUTH_DOMAIN)
  firebaseConfig.authDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
if (process.env.REACT_APP_FIREBASE_DATABASE_URL)
  firebaseConfig.databaseURL = process.env.REACT_APP_FIREBASE_DATABASE_URL;
if (process.env.REACT_APP_FIREBASE_PROJECT_ID)
  firebaseConfig.projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
if (process.env.REACT_APP_FIREBASE_STORAGE_BUCKET)
  firebaseConfig.storageBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
if (process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID)
  firebaseConfig.messagingSenderId =
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
if (process.env.REACT_APP_FIREBASE_APP_ID)
  firebaseConfig.appId = process.env.REACT_APP_FIREBASE_APP_ID;
if (process.env.REACT_APP_FIREBASE_MEASUREMENT_ID)
  firebaseConfig.measurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;

const firebaseApp: FirebaseApp =
  getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
const realtimeDb: Database = getDatabase(firebaseApp);
const messaging: Messaging = getMessaging(firebaseApp);
const auth: Auth = getAuth(firebaseApp);

export { firebaseApp, realtimeDb, messaging, auth, firebaseConfig };
